import { useStateWithSearchParams } from "../../hooks";
import { ButtonTabs } from "./ButtonTabs";

type SearchParams = {
  limit?: string;
};

export const TopTabs = () => {
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      limit: "10",
    },
  );

  const handleChange = (value: string) => {
    setSearchValue("limit", value.split(" ")[1] || "10");
  };

  return (
    <ButtonTabs
      currentTab={searchDict?.limit ? `Top ${searchDict?.limit}` : "Top 10"}
      onChange={handleChange}
      tabList={["Top 10", "Top 50", "Top 100"]}
    />
  );
};
